export default {
      id: "i-answer-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/sprite.svg#i-answer",
      toString: function () {
        return this.url;
      }
    }